const Search = () => {
    let trigger = $('.nav__search-mobile-toggle');
    let searchOpen = false;

    $(document).click(e => {
        if ($(e.target)[0] === $(trigger)[0] || $(e.target).parent()[0] === $(trigger)[0] || $(e.target)[0] === $('.nav__mobile-search-form')[0] || $(e.target)[0] === $('.nav__mobile-search-bar')[0]) {
            return false;
        } else {
            searchOpen = closeSearch();
        }
    })

    trigger.click(e => {
        if (!searchOpen) {
            searchOpen = openSearch();
        } else {
            searchOpen = closeSearch();
        }
    })
}

const openSearch = () => {
    $('.nav__mobile-search-form').addClass('nav__mobile-search-form--active');
    $('.nav__brand-link').css({
        'display': 'none'
    })
    $('.nav__mobile-search-form input').focus();
    $('body').addClass('menu-overlay');
    
    return true;
}

const closeSearch = () => {
    $('.nav__mobile-search-form').removeClass('nav__mobile-search-form--active');
    $('.nav__brand-link').css({
        'display': 'flex'
    })
    $('body').removeClass('menu-overlay');

    return false;
}   

export default Search;


// WEBPACK FOOTER //
// ./src/js/app/components/Search.js